/**
 * 内置配置
 * @creater liux
 * @Email   liuxing@autobio.com.cn
 * @Date    2019年8月8日 10:00:00
 */
export default {
  //系统名称
  name: '*** 系统',
  //token key
  token: 'token',
  //store 存储key
  store: 'store',
  //业务回调CODE,根据项目规定设置
  ResultCode: {
    //成功CODE
    SUCCESS_CODE: 0
  },
  Language: [
    { label:"zh_CN", value:"zh_CN" },
    { label:"en_US", value:"en_US" }
  ],
  permissions: {
    //菜单权限
    menu: 'menu',
    //按钮权限
    button: 'button'
  }
}